const colors = {
	white: '#FFFFFF',
	black: '#121211',
	grey: '#E5E5E5',
	blue: '#00A1E0',
	green: '#2DC27E',
	error: '#F98C7D',
	sand: '#EEEBE0',
	lightGrey: '#F7F7F7',
	border: '#E6E6E6',
	pink: '#FFA7A7',
	btnGreen: '#B8ECD6',
	btnTextGreen: '#115C38',
	btnYellow: '#FAF5C8',
	btnTextGrey: '#90908E',
	textGrey: 'rgba(33, 33, 30, 0.5)',
	pinkBar: '#E1A2FF',
	red: '#E80707',
	lightRed: '#EF5151',
	orange: '#F0751C',
	yellow: '#FFE031',
	lightYellow: '#EFF32D',
	darkBlue: '#002F61',
	lightWhite: '#C4C4C4',
	darkBlack: '#121B23',
	bgrdGrey: '#F7F7F9',
	sapphirine: '#005FC1',
	navText: '#7A7F8D',
	blueStatus: '#180B66',
	hoverBtn: '#0084FF',
	hoverGrey: '#D8D8D8',
	none: 'none',
	scrollbarColor: '#EDEDF3',
};

export default colors;
